<template>
    <v-dialog v-model="getModalCadastroBanco" max-width="720px">
        <v-card outlined :loading="$store.getters.getOverlay">
            <v-card-title>
                Cadastro de Banco
            </v-card-title>
            <v-form @submit.prevent="salvar" class="px-3">
                <v-card-text>
                    <v-layout row wrap class="">
                        <v-flex xs12 md6>
                            <v-text-field dense outlined v-model="getBanco.codigo_banco" label="Código do Banco"
                                class="ml-3 mr-3">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field dense outlined v-model="getBanco.nome" label="Nome" class="ml-2 mr-2"
                                required>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field dense outlined v-model="getBanco.agencia" label="Agência" class="ml-2 mr-2">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field dense outlined v-model="getBanco.conta" label="Conta" class="ml-2 mr-2">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field dense outlined v-model="getBanco.saldo_atual" v-mask label="Saldo Atual"
                                class="ml-2 mr-2"
                                v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" required>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="white--text" color="blue-grey" @click="setModalCadastroBanco(false)" outlined>Voltar</v-btn>
                    <v-btn v-if="getBanco.id && $helper.verificaPermissao('cadastrar-banco')" color="primary" @click="cadastrarBanco" outlined>Novo</v-btn>
                    <v-btn v-if="getBanco.id && $helper.verificaPermissao('excluir-banco')" color="error" @click.stop="setModalExcluirBanco(true)" outlined>Excluir</v-btn>
                    <v-spacer></v-spacer>

                    <v-btn color="success" @click="salvar" outlined :loading="$store.getters.getOverlay" v-if="$helper.verificaPermissao('cadastrar-banco') || $helper.verificaPermissao('atualizar-banco')">Salvar</v-btn>
                </v-card-actions>
            </v-form>

        </v-card>

        <ModalExcluirBanco />
    </v-dialog>
</template>

<script>
    import ModalExcluirBanco from "@/pages/banco/ModalExcluir"
    import { mapGetters, mapActions } from 'vuex'
    export default {
        components: {
            ModalExcluirBanco
        },
        computed: {
            ...mapGetters([
                'getBanco',
                'getModalCadastroBanco',
                'getPerfis',
                'getEmpresas',
                'getCargos',
            ])
        },
        methods: {
            ...mapActions([
                'setModalCadastroBanco',
                'setModalExcluirBanco',
                'cadastrarBanco',
                'salvarBanco',
                'atualizarBanco',
                'listarPerfil',
                'listarEmpresa',
                'listarCargo',
            ]),
            salvar() {
                if (this.getBanco.id) {
                    this.atualizarBanco(this.getBanco)
                } else {
                    this.salvarBanco(this.getBanco)
                }
            },
        },
        created() {
            this.listarPerfil()
            this.listarEmpresa()
            this.listarCargo()
        }
    }
</script>